<div class="tw-inline-flex tw-items-center tw-gap-2">
  @if (state() === 'saving') {
    <div
      class="tw-w-5 tw-h-5 tw-rounded-full tw-border-2 tw-border-gray-200 tw-border-t-blue-500 tw-animate-spin"
      aria-hidden="true"
    ></div>
    <span class="tw-text-sm tw-font-medium tw-text-blue-600 tw-font-inter">Saving...</span>
  } @else if (state() === 'saved') {
    <div
      class="tw-w-5 tw-h-5 tw-rounded-full tw-bg-green-500 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0"
      aria-hidden="true"
    >
      <svg class="tw-w-3 tw-h-3 tw-text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span class="tw-text-sm tw-font-medium tw-text-green-600 tw-font-inter">Saved</span>
  }
</div>
